import { useQuery } from '@tanstack/react-query'
import { getEvents } from 'services/api/marketing-api'

const useGetEvents = () => {
  return useQuery({
    queryKey: ['get-events-list'],
    queryFn: getEvents,
    select: (data) => data?.data,
  })
}

export default useGetEvents
